import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";
import { Tooltip } from "@jugl-web/ui-kit";

export interface TaskCardPillProps {
  label: ReactNode;
  hint?: ReactNode;
  backgroundColor?: string;
  textColor?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  className?: string;
}

export const PILL_BASE_BG_COLOR = "#F9F9F9";
export const PILL_BASE_TEXT_COLOR = "#40494D";

export const TaskCardPill: FC<TaskCardPillProps> = ({
  label,
  hint,
  backgroundColor = PILL_BASE_BG_COLOR,
  textColor = PILL_BASE_TEXT_COLOR,
  startIcon,
  endIcon,
  className,
}) => (
  <Tooltip
    placement="bottom"
    isDisabled={!hint}
    className="px-3 font-secondary text-sm leading-3"
    renderTrigger={({ ref, props }) => (
      <div
        ref={ref}
        className={cx(
          "flex items-center gap-1.5 overflow-hidden rounded-md px-1.5 py-0.5",
          className
        )}
        style={{
          backgroundColor,
          color: textColor,
        }}
        {...props}
      >
        {startIcon && <div className="shrink-0 leading-[0]">{startIcon}</div>}
        <span className="flex items-center truncate text-xs leading-2">
          {label}
        </span>
        {endIcon && <div className="shrink-0 leading-[0]">{endIcon}</div>}
      </div>
    )}
  >
    {hint}
  </Tooltip>
);
